import React from "react";
export const path = "/master/immediate";

export const handler = data => {
  // return {
  //   top: {
  //     html: `
  //       <div class="callcenter_notice">
  //         年末年始の休業期間は、下記の通りとなります。<br/>
  //         <br/>
  //         <div class="emphasis">
  //           ＜休業期間＞<br/>
  //           2019年1月1日(火) − 2019年1月3日(木)
  //         </div>
  //         なお、ホームページからのお申込み・<a target="_blank" href="/mypage3/?action=cancel">ご解約</a>お申し出は24時間承っております。<br/>
  //         ※ホームページからのお申し込みは、各物件詳細ページからご利用いただけます。<br/>
  //       </div>
  //     `,
  //     startTime: 1546214400,
  //     endTime: 1546560000,
  //   },
  //   modalMember: {
  //     html: `
  //       <div class="callcenter_notice">
  //         年末年始の休業期間は、下記の通りとなります。<br/>
  //         <br/>
  //         <div class="emphasis">
  //           ＜休業期間＞<br/>
  //           2019年1月1日(火) − 2019年1月3日(木)
  //         </div>
  //         なお、ホームページからのお申込み・<a target="_blank" href="/mypage3/?action=cancel">ご解約</a>お申し出は24時間承っております。<br/>
  //         ※ホームページからのお申し込みは、各物件詳細ページからご利用いただけます。<br/>
  //         <div class="callcenter_notice_attention">
  //           鍵の紛失・盗難等は、緊急対応窓口で承っております。<br/>
  //           下記番号までご連絡ください。<br/>
  //           048-971-5968
  //         </div>
  //       </div>
  //     `,
  //     startTime: 1546214400,
  //     endTime: 1546560000,
  //   },
  //   modalVisitor: {
  //     html: `
  //       <div class="callcenter_notice">
  //         年末年始の休業期間は、下記の通りとなります。<br/>
  //         <br/>
  //         <div class="emphasis">
  //           ＜休業期間＞<br/>
  //           2019年1月1日(火) − 2019年1月3日(木)
  //         </div>
  //         なお、ホームページからのお申込み・<a target="_blank" href="/mypage3/?action=cancel">ご解約</a>お申し出は24時間承っております。<br/>
  //         ※ホームページからのお申し込みは、各物件詳細ページからご利用いただけます。<br/>
  //       </div>
  //     `,
  //     startTime: 1546214400,
  //     endTime: 1546560000,
  //   },
  //   modalOther: {},
  // }
  return data.excComment;
};



// WEBPACK FOOTER //
// ./lib/masterData/schemas/excComment.js